<template>
  <component
    :is="isTag"
    ref="button"
    class="baseButton"
    :class="[
      {disabled : isDisabled},
      design !== '' ? design : ''
    ]"
    @click="clicked"
  >
    <span
      class="baseButton__button__label"
      :class="{disabled : isDisabled && !btnLabelEnable}"
    >{{ label }}
    </span>
  </component>
</template>

<script>
export default {
  name: 'BaseButtonChoun',
  props: {
    // a タグなどに変更したい場合に使用
    tag: {
      type: String,
      default: 'div'
    },
    label: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: '/'
    },
    isDisabled:{
      type: Boolean,
      default: false
    },
    btnLabelEnable: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
      default: ''
    },
  },
  computed: {
    // タグを設定
    isTag () {
      return this.tag
    }
  },
  mounted () {
    // href 設定
    if (this.tag === 'a') {
      this.$refs.button.setAttribute('href', this.href)
    }
  },
  methods: {
    clicked(){
      if(!this.isDisabled) {
        this.$emit('clicked')
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.baseButton {
  background: $diary_orange;
  border-radius: 35px;
  min-width: 100px;
  font-weight: 600;
  font-size: 13px;
  color: $diary_white;
  cursor: pointer;
  text-align: center;
  position: relative;
  height: 55px;
  line-height: 55px;
  @include mq('sp') {
    font-size: 14px;
  }
  &.min {
    height: 48px;
    line-height: 48px;
  }
  &.cancel {
    background: $diary_white;
    border: 2px solid $diary_orange;
    color: $diary_orange;
    height: 55px;
    line-height: 53px;
    &.min {
      height: 48px;
      line-height: 46px;
    }
  }
  &.disabled {
    background: $diary_white;
    pointer-events: none;
    border: 2px solid $diary_disabled;
    color: $diary_disabled;
    height: 55px;
    line-height: 53px;
    font-weight: bold;
    &.min {
      height: 48px;
      line-height: 46px;
    }
  }
  .icon {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/BaseButtonChoun.vue